import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-icon',
    templateUrl: './info-icon.component.html',
    styleUrls: ['info-icon.component.css']
})

export class InfoIconComponent implements OnInit {

    @Input() message: string = "";
    @Input() offsetLeft: boolean = false;
    @Input() offsetRight: boolean = false;
    
    public isToolTipVisible: boolean = false;
    // TODO: REMOVE THIS LATER
    public visible: boolean = false;
    
    constructor() {
        
    }

    ngOnInit() {
        
    }

    mouseEnter() {
        this.isToolTipVisible = true;
    }

    mouseLeave() {
        this.isToolTipVisible = false;
    }
}